import React, {useEffect} from 'react';
import './style.scss';
import Slider from 'react-slick';
import AwNextArrow from '../SliderWrap/AwNextArrow';
import AwPrevArrow from '../SliderWrap/AwPrevArrow';
import { loadSlickCSS } from '../../shared/helpers';
import { tl_data } from './translations.js';

const BeyondMeatSlider = props => {
   
    useEffect(() => {
        loadSlickCSS()
        //console.log('list ',tl_data);
    },[]);

    let settings = {
        className: "center",
        swipeToSlide: true,
        centerMode: true,
        infinite: true,
        centerPadding: "80px",
        slidesToShow: 3,
        dots:false,
        speed: 500,
        nextArrow: <AwNextArrow />,
        prevArrow: <AwPrevArrow />,
  
  
        responsive: [
            {
                breakpoint:850,
                settings: {
                    className: "center",
                    swipeToSlide: true,
                    centerMode: true,
                    infinite: true,
                    centerPadding: "80px",
                    slidesToShow: 1,
                    dots:false,
                    speed: 500,
                    arrows:false
                }
            }
        ]
    };

    // Set dynamic path for images
    const images = require.context('./i', true);
     
    let daList = tl_data.map((item, i) => {
        //console.log('item title ', item.title);
        let imgSrc = item.image[props.lang];
        let img = images('./' + imgSrc);

        return <div key={i} className="item">
            <div className="itemcol">
            
                <img src={img} className="" alt=""  />
                <div className="copy-wrap">
                    <h3>{item.title[props.lang]}</h3>
                    <p>{item.description[props.lang]}</p>
                </div>

            </div>
        </div>;

      });
  


    return (

        <div className="beyondmeat-slider-wrap">
            <Slider {...settings}>
                {daList}
            </Slider>
        </div>

    )
}
export default BeyondMeatSlider;